import config from "../Context/Config"; // Adjust the path based on your project
import { showSwal } from "./swal";
import { handleApiError } from "./error";

export const checkCode = async (code,tryRefresh) => {
    try {
        const response = await fetch(`${config.API_BASE_URL}/check_code`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${localStorage.getItem("digital-form-idtoken")}`,
                "action_id": config.ACTIONID["edit"],
                "practice": localStorage.getItem("digital-form-dept-practice")
            },
            body: JSON.stringify({ code }),
        });

        if (response.ok) {
            const data = await response.json();
            if (data === "code not found") {
                return false;
            }
            return true;
        }

        await handleApiError(response.status, async () => {
            // Retry original call after refresh
            return await checkCode(code);
        },tryRefresh);

    } catch (error) {
        console.error("Unexpected error in checkCode:", error);
        showSwal("error", "Network Error", "Unable to connect to server. Please try again later.");
    }
};
